/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select all order entitoes
 * @param {any} state The state management `state`
 * @returns {Array<OrderEntity>} The order entites that have been selected from the store
 */
const orderEntitiesSelector = createSelector(ordersSelector, (orders) => orders.entities);

export default orderEntitiesSelector;
